<template>
  <div>
    <el-row style="margin-top:10px">
      <el-col>
        <el-button size="medium" @click="addLine">新增</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top:10px">
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <!-- <el-table-column prop="ACCOUNT" label="账号"></el-table-column> -->
          <el-table-column prop="CELLPHONE" label="联系电话"></el-table-column>
          <el-table-column prop="DRIVER" label="联系人"></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" @click="modify(scope.row)">修改</el-button>
              <el-button type="text" @click="deleteAccount(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="新增账号" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm">
        <!-- <el-form-item label="账号：" :label-width="formLabelWidth">
          <el-input v-model="addForm.ACCOUNT" placeholder="请输入账号"></el-input>
        </el-form-item> -->
        <el-form-item label="联系电话：" :label-width="formLabelWidth">
          <el-input v-model="addForm.CELLPHONE" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" :label-width="formLabelWidth">
          <el-input v-model="addForm.DRIVER" placeholder="请输入联系人"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitAdd()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改账号" center :visible.sync="modifyVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="modifyForm" ref="addForm">
        <!-- <el-form-item label="账号：" :label-width="formLabelWidth">
          <el-input v-model="modifyForm.ACCOUNT" placeholder="请输入账号"></el-input>
        </el-form-item> -->
        <el-form-item label="联系电话：" :label-width="formLabelWidth">
          <el-input v-model="modifyForm.CELLPHONE" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" :label-width="formLabelWidth">
          <el-input v-model="modifyForm.DRIVER" placeholder="请输入联系人"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="modifyVisible = false">取 消</el-button>
        <el-button size="small" @click="submitmodify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      tableData: [],
      addFormVisible: false,
      addForm: {},
      modifyVisible: false,
      modifyForm: {},
      formLabelWidth: '100px',
      accountMsg: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 删除
    deleteAccount(row) {
      this.$confirm('是否删除该账户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '12011',
          OTYPE: 8,
          RECORD_ID: row.RECORD_ID,
        };
        http.post(params).then((result) => {
          this.getList();
          this.$message.show({ text: '删除成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消操作' });
      });
    },
    // 拉取账户列表
    getList() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 6,
        CAR_ID: this.$route.params.id,
      };
      http.post(params).then((result) => {
        if (result[0]) {
          this.tableData = result;
        } else {
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 修改
    modify(row) {
      this.accountMsg = row;
      // this.$set(this.modifyForm, 'ACCOUNT', row.ACCOUNT);
      this.$set(this.modifyForm, 'DRIVER', row.DRIVER);
      this.$set(this.modifyForm, 'CELLPHONE', row.CELLPHONE);
      this.modifyVisible = true;
    },
    // 修改确认
    submitmodify() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 7,
        RECORD_ID: this.accountMsg.RECORD_ID,
      };
      // if (this.modifyForm.ACCOUNT) {
      //   params.ACCOUNT = this.modifyForm.ACCOUNT;
      // }
      if (this.accountMsg.DRIVER != this.modifyForm.DRIVER) {
        params.DRIVER = this.modifyForm.DRIVER;
      }
      if (this.accountMsg.CELLPHONE != this.modifyForm.CELLPHONE) {
        params.CELLPHONE = this.modifyForm.CELLPHONE;
      }
      if (!this.validate(this.modifyForm.CELLPHONE)) {
        return false;
      }
      http.post(params).then((result) => {
        this.getList();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.modifyVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增
    addLine() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    // 新增确认
    submitAdd() {
      const params = {
        SERVICE_ID: '12011',
        OTYPE: 5,
        CAR_ID: this.$route.params.id,
      };
      // if (this.addForm.ACCOUNT) {
      //   params.ACCOUNT = this.addForm.ACCOUNT;
      // }
      if (this.addForm.DRIVER) {
        params.DRIVER = this.addForm.DRIVER;
      }
      if (this.addForm.CELLPHONE) {
        params.CELLPHONE = this.addForm.CELLPHONE;
      }
      if (!this.validate(params.CELLPHONE)) {
        return false;
      }
      http.post(params).then((result) => {
        this.getList();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.addFormVisible = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 验证手机号
    validate(str) {
      if (!validation.手机号验证(str)) {
        this.$message.show({ text: '输入的手机号格式不正确，请重新输入', type: 'warning' });
        return false;
      }
      return true;
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/sortingAndDistribution/accountManagement.vue